"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIStatusTag;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UITag = _interopRequireDefault(require("./UITag"));

var RenderProp = _interopRequireWildcard(require("../utils/propTypes/renderProp"));

var _UIStatusDot = _interopRequireDefault(require("./UIStatusDot"));

var _colors = require("HubStyleTokens/colors");

var _Styles = require("../utils/Styles");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", "\n  background-color: transparent;\n  border-color: transparent;\n  color: ", ";\n  padding-left: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var UnenclosedTag = (0, _styledComponents.default)(_UITag.default).withConfig({
  displayName: "UIStatusTag__UnenclosedTag",
  componentId: "bdwckk-0"
})(_templateObject(), _Styles.FONT_FAMILIES.default, _colors.EERIE);

function UIStatusTag(_ref) {
  var children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      hollow = _ref.hollow,
      StatusDot = _ref.StatusDot,
      use = _ref.use,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "className", "color", "hollow", "StatusDot", "use"]);
  return _react.default.createElement(UnenclosedTag, (0, _extends2.default)({
    use: use
  }, rest, {
    className: (0, _classNames.default)('private-tag--unenclosed', className, {
      'private-tag--hollow': hollow
    })
  }), _react.default.createElement("span", {
    className: "private-tag--unenclosed__text"
  }, _react.default.createElement(StatusDot, {
    color: color,
    hollow: hollow,
    use: use
  }), children));
}

UIStatusTag.propTypes = (0, _extends2.default)({}, _UITag.default.propTypes, {
  color: _react.PropTypes.string,
  hollow: _react.PropTypes.bool.isRequired,
  StatusDot: RenderProp.getPropType(_UIStatusDot.default).isRequired
});
UIStatusTag.defaultProps = (0, _extends2.default)({}, _UITag.default.defaultProps, {
  hollow: false,
  StatusDot: _UIStatusDot.default,
  use: 'info'
});
UIStatusTag.displayName = 'UIStatusTag';
module.exports = exports.default;